import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { Button } from '@whitbread-eos/atoms';
import { akamaiImageLoader, formatAssetsUrl, isIVMEnabled, useSemanticTypography } from '@whitbread-eos/utils';
import Image from 'next/image';
import HotelRestaurantMenuDescription from './HotelRestaurantMenuDescription.component';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function HotelRestaurantMenuContent(_ref) {
  var menu = _ref.menu,
    isTabPanel = _ref.isTabPanel;
  var getTypographyProps = useSemanticTypography();
  var cardStyles = {
    flexWrap: 'wrap',
    m: isTabPanel ? '0.25rem -1rem -1rem -1rem' : 0,
    pt: isTabPanel ? 0 : 5
  };
  return _jsxs(Flex, _objectSpread(_objectSpread({}, cardStyles), {}, {
    "data-testid": "".concat(menu.name, "-menu"),
    children: [renderMenuImage(), _jsxs(Box, {
      w: {
        sm: 'full',
        md: '50%'
      },
      "data-testid": "hdp_restaurantMenuContent",
      children: [renderMenuDescription(), renderMenuButton()]
    })]
  }));
  function renderMenuImage() {
    var _menu$imageSrc, _menu$name;
    var imageContainerStyles = {
      position: 'relative',
      mr: {
        base: 0,
        md: 6
      },
      mb: 5,
      w: {
        base: 'full',
        md: 'calc(50% - var(--chakra-space-6))'
      }
    };
    return _jsx(Box, _objectSpread(_objectSpread({}, imageContainerStyles), {}, {
      "data-testid": "".concat(menu.name, "-menu-image"),
      children: _jsx(Image, {
        src: formatAssetsUrl((_menu$imageSrc = menu.imageSrc) !== null && _menu$imageSrc !== void 0 ? _menu$imageSrc : ''),
        alt: (_menu$name = menu.name) !== null && _menu$name !== void 0 ? _menu$name : '',
        width: 400,
        height: 250,
        style: {
          width: '100%',
          height: 'auto'
        },
        loader: isIVMEnabled() ? akamaiImageLoader : undefined
      })
    }));
  }
  function renderMenuDescription() {
    var _menu$description;
    return _jsx(Box, {
      mb: "1.188rem",
      w: "full",
      children: _jsx(HotelRestaurantMenuDescription, {
        menuDescription: (_menu$description = menu.description) !== null && _menu$description !== void 0 ? _menu$description : ''
      })
    });
  }
  function renderMenuButton() {
    var buttonStyles = {
      mb: '1.188rem',
      w: {
        base: 'full',
        mobile: 'full',
        xs: 'full',
        sm: '48.5%',
        md: '37%',
        lg: '32%',
        xl: '32%'
      },
      minWidth: {
        sm: '14.3rem',
        md: '16.6rem',
        lg: '24.5rem',
        xl: '26.25rem'
      },
      sx: {
        ':hover': {
          background: 'inherit',
          boxShadow: 'none',
          color: '#9f78a3'
        }
      }
    };
    if (!(menu !== null && menu !== void 0 && menu.menuSrc)) {
      return null;
    }
    return _jsx(Button, _objectSpread(_objectSpread(_objectSpread({
      size: "md",
      variant: "tertiary"
    }, buttonStyles), getTypographyProps({}, menuButtonSemanticTypography)), {}, {
      onClick: () => {
        var _menu$menuSrc;
        return window.open(formatAssetsUrl((_menu$menuSrc = menu === null || menu === void 0 ? void 0 : menu.menuSrc) !== null && _menu$menuSrc !== void 0 ? _menu$menuSrc : ''), '_blank');
      },
      children: menu.menuLabel
    }));
  }
}
var menuButtonSemanticTypography = {
  textStyle: 'body-m-emphasis'
};